<template>
  <div class="main_view">
    <div class="waterfall">
      <vue-waterfall-easy
        ref="waterfall"
        :imgsArr="dataList"
        :srcKey="'image'"
        :maxCols="2"
        :gap="15"
        :mobileGap="15"
      >
        <div class="img-info" slot-scope="props">
          <p class="note-play-img" v-show="showPlay"></p>
          <div class="note-reads"><p class="reads-img"></p><div class="reads-txt">{{ props.value.reads_count}}</div></div>
          <span class="text-info">{{ props.value.title }}</span>
          <div class="note-append">
            <div class="note-user">
              <div class="user-image-wrapper">
                <img
                  :src="props.value.kol_avatar"
                  class="user-image">
              </div>
              <span class="name">{{ props.value.kol_nickname }}</span>
            </div>
            <div class="like">
              <p class="heart"></p>
              <span class="likes">{{ props.value.liked_count }}</span>
            </div>
          </div>
        </div>
        <div slot="waterfall-over"></div>
      </vue-waterfall-easy>
    </div>
  </div>
</template>

<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import process from "shelljs";
export default {
  name: "BigdataNoteRead",
  components: {
    vueWaterfallEasy
  },
  data() {
    return {
      uid: '',
      showPlay: true,
      dataList: [], //下拉列表-数据
    }
  },
  methods: {
    getListData() {
      let base = '/api'
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com'
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_ai_create'
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'content': this.uid,
          'ctype': 'reads',
        })
      }).then((res) => {
        if (res.data.error===1) {
          return this.$message({
            type: "error",
            message: res.data.message,
          })
        }
        this.dataList = res.data.result
        this.showPlay = true
        if (res.data.result[0].type === 'normal') {
          this.showPlay = false
        }
        // 不上拉加载更多了
        this.$refs.waterfall.waterfallOver()
      }).catch((res) => {
      })
    }
  },
  mounted () {
    console.dir(this.$cookies);
    this.uid = this.$route.query.uid;
    this.getListData();
  },
  metaInfo: {
    title: "袤-AI数据挖掘系统",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  height 100vh
  -webkit-overflow-scrolling touch
  background-color #fafafa
  display flex
  flex-direction column
  width 100%
  overflow-y scroll
  overflow-x hidden
  position absolute

  .waterfall {
    position absolute
    top 0
    bottom 0
    width 100%
    height 1500px
  }

/deep/ .vue-waterfall-easy-container {
  a.img-inner-box {
    border-radius  5px !important
    background-color  white !important
    box-shadow  none !important
    //overflow hidden
    .img-wraper > img {
      //object-fit cover !important
      border-radius  5px 5px 0 0 !important
    }
  }

  .img-info {
    display  flex
    flex-direction  column
    justify-content  flex-start
    align-items  flex-start

    .note-play-img {
      left 84%
      top -100%
      position absolute
      height 25px
      width 25px
      background-image url('/static/images/bigdata/xhs_note_play.png')
      background-repeat no-repeat
      background-size contain
    }

    .note-reads {
      display flex
      flex-direction row
      margin-top -26px
      margin-left 10px
      height 18px
      background-color  #000
      opacity 0.45
      border-radius 10px 10px 10px 10px

      .reads-txt {
        margin-top 2px
        font-size  8px
        text-align justify
        padding 0 8px 0 4px
        color #fff
      }

      .reads-img {
        margin-top 2px
        margin-left 6px
        height 14px
        width 14px
        background-image url('/static/images/bigdata/xhs_note_eye.png')
        background-repeat no-repeat
        background-size contain
      }
    }

    .text-info {
      margin-top 15px
      margin-left 10px
      color  #333333
      font-size  14px
      font-weight  500
      line-height  24px
    }

    .note-append {
      padding-left 10px
      width 90%
      display  flex
      flex-direction  row
      justify-content  space-between

      .note-user {
        display  flex
        flex-direction  row
        align-items  center

        .user-image-wrapper {
          width  25px
          height  25px
          border-radius  50%
          position  relative
          overflow  hidden

          .user-image {
            position  absolute
            width  100%
            height  100%
          }
        }

        .name {
          white-space  nowrap
          text-overflow  ellipsis
          overflow  hidden
          margin-left  6px
          color  #666666
          font-size  10px
        }
      }

      .like {
        display  flex
        flex-direction  row
        align-items  center

        .heart {
          width 16px
          height 16px
          background-image url('/static/images/bigdata/xhs_note_liked.png')
          background-repeat no-repeat
          background-size contain
        }

        .likes {
          margin-left 4px
          color #666666
          font-size 13px
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/bigdata/BigdataNoteRead.vue